export default {
    //ProductList
    your_created_projects: "Ihre erstellten Kurse",
    new_project: "Neuer Kurs",
    projects_name: "KURS-NAME",
    update_at: 'Aktualisiert am ',
    coming_soon: 'Demnächst verfügbar',
    search_your_project: 'Suchen Sie nach Ihrem Kurs...',
    project_name: 'Name des Kurses',
    loading_products: 'Produkte laden...',

    //ProductEditComponent
    modify_project: 'Ändern Sie Ihren Kurs',
    general: 'Allgemein',
    branding: 'Branding',
    product_page: 'Produkt Seite',
    sale: 'Verkauf',
    seo_text: 'SEO',
    projects: 'Projekte',

    //CategoriesSlideOverComponent
    categories: 'Kategorien',
    text_category: 'Klassifizieren Sie Ihre Produkte nach Kategorien, um Ihren Studenten den Kauf Ihrer Kurse zu erleichtern.',
    select_category: 'Kategorie auswählen...',
    ebook: 'E-book',
    online_project: 'Online-Kurs',
    blended_learning: 'Blended Learning-Kurs',
    online_program: 'Online-Programm',
    webinar_consulting: 'Webinar / Online-Beratung',
    remove_category: 'Kategorie entfernen',
    href_help: 'Ich würde gerne mehr über die Kategorien erfahren',

    //ProductEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Kategorie',
    duration: 'Dauer',
    featured_product: 'Produkt-Spotlight',
    delete_project: 'Projekt löschen',
    warning_delete: 'Warnung!',
    message_delete_project: 'Wenn Sie das Projekt löschen, gehen alle Daten unwiderruflich verloren.',
    question_delete_project: 'Sind Sie sicher, dass Sie dieses Projekt löschen wollen?',
    delete: 'Löschen',
    confirmation_delete_project: '(*) Dieses Feld ist erforderlich, um das Projekt zu löschen.',
    //PageComponent
    principal_page: 'Hauptseite',
    objectives_presentation: 'Präsentation und Ziele',
    learning_objectives: 'Vergessen Sie nicht, die Lernziele kurz zu beschreiben.',
    teaching_staff: 'Methodik und Lehrpersonal',
    public: 'Öffentlich',
    content: 'Inhalt',
    sidebar: 'Seitenleiste',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Laden Sie Ihr Banner hoch',
    banner_format: 'PNG, JPG, GIF bis zu 3 MB',
    promotional_video: 'Werbevideo',
    video_url: 'Video-URL',
    video_info: 'Wenn Sie ein Werbevideo haben, geben Sie hier die Url des Videos auf Youtube oder Vimeo an.',
    //SellComponent
    price_management: 'Preis-Management',
    sell_price: 'Verkaufspreis',
    tax: 'In €. (-3% Steuer)',
    price_offer: 'Angebotspreis',
    text_configuration: 'Text-Konfiguration',
    free_text_button: 'Freier Buy Button Titel',
    text_if_free: 'Dieser Titel erscheint, wenn Ihr Produkt kostenlos ist',
    on_sale: 'Zu verkaufen',
    sale_info: 'Wenn Ihr Produkt aktiviert ist, wird es zum Verkauf angeboten',

    //SeoComponent
    seo_configuration: 'SEO-Konfiguration',
    seo_title: 'SEO-Titel',
    slug: 'Slug',
    seo_description: 'SEO Beschreibung',

    //ProjectListComponent
    featured: 'Ausgewählt',
    classroom: 'Klassenzimmer',
    slug_text: 'slug',
    product: 'Produkt',
    products: 'Produkte',
    preview: 'Vorschau',

    //AttachProjectSlideOverComponent
    attach_project: 'Assoziiertes Projekt',
    loading_projects: 'Zugehörige Projekte laden...',
    project_selected: 'Ausgewähltes Projekt',
    quest_attach_project: 'Möchten Sie dieses Projekt anhängen?',
    back: 'Zurück zu',
    add_project: 'Projekt anhängen',
    close_panel: 'Paneel schließen',

    //ProjectAttachedListComponent
    attached_projects: 'Assoziierte Projekte',
    loading_products_attached: 'Laden von zugehörigen Produkten...',
    unattach_project: 'Projekt trennen',
    info_unattach_project: 'Wenn das Projekt vom Produkt getrennt wird, können Schüler, die das Produkt kaufen, nicht mehr auf das Projekt zugreifen.',
    quest_unattach_project: 'Sind Sie sicher, dass Sie das Projekt abkoppeln wollen? ',

    // ProductList · paginación y estados
    search_label: 'Kurse suchen',
    actions: 'Aktionen',
    edit_product: 'Kurs bearbeiten',
    load_error: 'Die Kurse konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    no_results_title: 'Keine Kurse passen zu „{search}“',
    no_results_text: 'Versuchen Sie einen anderen Namen oder prüfen Sie die Schreibweise.',
    clear_search: 'Suche löschen',
    empty_title: 'Sie haben noch keinen Kurs erstellt',
    empty_text: 'Erstellen Sie Ihren ersten Kurs, um ihn in Ihrer Akademie zu verkaufen.',
    product_published: 'Der Kurs wurde veröffentlicht',
    product_unpublished: 'Die Veröffentlichung des Kurses wurde aufgehoben',
    unexpected_error: 'Ein unerwarteter Fehler ist aufgetreten',

    // TipTapEditorComponent · menú de bloques (página de producto)
    blocks_menu: 'Blöcke',
    blocks_menu_label: 'Vorgefertigten Block einfügen',
    block_badge: 'Hervorgehobener Hinweis',
    block_key_facts: 'Eckdaten',
    block_separator: 'Trennlinie',
    block_price_enroll: 'Preis und Anmeldung',

    // BlockControls · controles de cada bloque
    block_move_up: '„{block}“ nach oben',
    block_move_down: '„{block}“ nach unten',
    block_remove: '„{block}“ entfernen',
    block_remove_confirm_title: 'Diesen Block entfernen?',
    block_remove_confirm_text: 'Der Block wird aus dem Text entfernt. Bis zum Speichern können Sie ihn mit Rückgängig (Strg+Z) wiederherstellen.',
    block_remove_confirm_action: 'Entfernen',

    // PriceEnrollNodeView · bloque «Precio e inscripción»
    price_enroll_price: 'Preis oder Text',
    price_enroll_price_placeholder: 'z. B. 1.200 € / Gefördert / Kostenlos',
    price_enroll_button_text: 'Button-Text',
    price_enroll_button_url: 'Button-Link',
    price_enroll_note: 'Hinweis (optional)',
    price_enroll_button_color: 'Button-Farbe',
    price_enroll_url_invalid: 'Geben Sie einen Link ein, der mit https://, http:// oder mailto: beginnt',
    price_enroll_no_button: 'Ohne gültigen Link wird der Button auf der öffentlichen Seite nicht angezeigt.',
    price_enroll_default_button: 'Jetzt anmelden',

    // InfoPricesNodeView · bloque «Tarifas informativas»
    block_info_prices: 'Informative Preise',
    info_prices_title: 'Titel (optional)',
    info_prices_title_placeholder: 'z. B. Modul Arbeitsinspektion',
    info_prices_row: 'Zeile {n}',
    info_prices_row_label: 'Bezeichnung',
    info_prices_row_label_placeholder: 'z. B. Mitglieder',
    info_prices_row_amount: 'Betrag',
    info_prices_row_amount_placeholder: 'z. B. 360 € / Gefördert',
    info_prices_add_row: 'Zeile hinzufügen',
    info_prices_remove_row: 'Zeile {n} entfernen',
    info_prices_accent_color: 'Farbe der ersten Zeile',
    info_prices_default_row_1: 'Normaltarif',
    info_prices_default_row_2: 'Ermäßigter Tarif',

    // LinkButtonNodeView · bloque «Botón de enlace»
    block_link_button: 'Link-Button',
    link_button_default_text: 'Mehr erfahren',
    link_button_text: 'Button-Text',
    link_button_url: 'Link',
    link_button_url_invalid: 'Gib einen Link ein, der mit https://, http:// oder mailto: beginnt',
    link_button_no_link: 'Ohne gültigen Link wird der Button nicht angezeigt. Füge einen Link hinzu, der mit https://, http:// oder mailto: beginnt',
    link_button_color: 'Button-Farbe',
    link_button_variant: 'Stil',
    link_button_variant_solid: 'Gefüllt',
    link_button_variant_outline: 'Kontur',

    // TipTapEditorComponent · barra de herramientas (FE-054)
    editor_toolbar: 'Textformatierung',
    editor_bold: 'Fett',
    editor_italic: 'Kursiv',
    editor_underline: 'Unterstrichen',
    editor_strike: 'Durchgestrichen',
    editor_heading_2: 'Überschrift 2',
    editor_heading_3: 'Überschrift 3',
    editor_heading_4: 'Überschrift 4',
    editor_bullet_list: 'Aufzählung',
    editor_ordered_list: 'Nummerierte Liste',
    editor_align_left: 'Linksbündig',
    editor_align_center: 'Zentriert',
    editor_align_right: 'Rechtsbündig',
    editor_blockquote: 'Zitat',
    editor_code_block: 'Codeblock',
    editor_link: 'Link',
    editor_remove_link: 'Link entfernen',
    editor_insert_image: 'Bild einfügen',
    editor_horizontal_rule: 'Horizontale Linie',
    editor_text_color: 'Textfarbe',
    editor_remove_color: 'Farbe entfernen',
    editor_undo: 'Rückgängig',
    editor_redo: 'Wiederholen',
    editor_edit_html: 'HTML bearbeiten',
    editor_insert_badge: 'Hervorgehobenen Hinweis einfügen',
    editor_insert_icon_list: 'Liste mit Symbolen einfügen',
    editor_insert_raw_html: 'Eigenes HTML einfügen (ohne Einschränkungen)',
    editor_badge_panel: 'Hervorgehobener Hinweis:',
    editor_badge_border: 'Rahmen',
    editor_badge_text: 'Text',
    editor_badge_background: 'Hintergrund',
    editor_icon_list_panel: 'Liste mit Symbolen:',
    editor_icon_list_color: 'Symbolfarbe',
    editor_link_url: 'Link-URL:',
    editor_image_url: 'Bild-URL:',
    editor_apply: 'Übernehmen',
    editor_cancel: 'Abbrechen',
    editor_html_source: 'HTML-Code',
}
